import sha256 from 'crypto-js/sha256';

function getHashedValue(value) {
	const hash = sha256(value);
	return hash.toString();
}

export default function getHashedEmailData({ booking_role, booking } = {}) {
	const hashedGuestEmail = getHashedValue(booking?.contactDetails?.email);
	let hashedBookerEmail = '';
	if (booking_role === 'someone else') {
		const booker = booking?.customers?.find(customer => {
			return customer?.contactType === 'BOOK_FOR';
		});
		if (Array.isArray(booker?.emails)) {
			hashedBookerEmail = getHashedValue(booker?.emails[0]?.email);
		} else if (booker?.email) {
			hashedBookerEmail = getHashedValue(booker?.email);
		}
	}

	return {
		guest_email_hashed: hashedGuestEmail || '',
		booker_email_hashed: hashedBookerEmail || '',
	};
}
